import { render, staticRenderFns } from "./QuickNavigation.vue?vue&type=template&id=230eba9d&"
import script from "./QuickNavigation.vue?vue&type=script&lang=js&"
export * from "./QuickNavigation.vue?vue&type=script&lang=js&"
import style0 from "./QuickNavigation.vue?vue&type=style&index=0&id=230eba9d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports